import PoolHero from './components/PoolHero';
import PoolServices from './components/PoolServices';
import PoolTypesElPaso from './components/PoolTypesElPaso';
import ComparisonChecklist from './components/ComparisonChecklist';
import PoolFAQ from './components/PoolFAQ';
import ContractorDirectory from './components/ContractorDirectory';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { useEffect } from 'react';

export default function Pool() {
  useEffect(() => {
    document.title = 'Swimming Pool Contractors El Paso | Custom Pool Design & Construction';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Find expert swimming pool contractors in El Paso for custom pool design, construction, renovation, and maintenance. Get free consultations from licensed pool builders.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'swimming pool contractors El Paso, pool builders, custom pool design, pool construction, pool renovation');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <PoolHero />
      <PoolServices />
      <PoolTypesElPaso />
      <ComparisonChecklist />
      <PoolFAQ />
      <ContractorDirectory />
      <Footer />
    </div>
  );
}
